"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxiosInstance = getAxiosInstance;
exports.getServicesAxiosClient = getServicesAxiosClient;
const axios_1 = __importDefault(require("axios"));
const processEnv_1 = __importDefault(require("./processEnv"));
const uuidV4_1 = require("./uuidV4");
function getAxiosInstance(request) {
    return createAxiosInstance({}, request);
}
function getServicesAxiosClient(request) {
    if (request) {
        const headers = {
            'x-api-key': processEnv_1.default.getValueOrThrow('SERVICES_API_KEY'),
        };
        if (request.session?.accessToken) {
            headers.Authorization = `bearer ${request.session.accessToken}`;
        }
        else if (request.header('Authorization')) {
            headers.Authorization = request?.header('Authorization');
        }
        const baseConfig = {
            headers,
            baseURL: processEnv_1.default.getValueOrThrow('SERVICES_HOST'),
        };
        return createAxiosInstance(baseConfig);
    }
    return createAxiosInstance({});
}
function createAxiosInstance(baseConfig = {}, request) {
    const requestId = request?.id || (0, uuidV4_1.uuidV4)();
    const realBaseConfig = {
        ...baseConfig,
        headers: {
            ...(baseConfig.headers || {}),
            'x-correlation-id': requestId,
            Accept: 'application/json',
        },
    };
    const axiosInstance = axios_1.default.create(realBaseConfig);
    axiosInstance.interceptors.request.use((config) => {
        console.log(`${requestId} Invoked ${config.url}`);
        return config;
    });
    axiosInstance.interceptors.response.use((response) => {
        console.log(`${requestId} Received ${response.status} from ${response.config.url}`);
        return response;
    }, (error) => {
        const errorResponse = error.response;
        const { message } = errorResponse?.data;
        if (errorResponse && errorResponse?.status >= 500) {
            console.error(`${requestId} Received ${errorResponse?.status} from ${errorResponse?.config?.url}: ${message}.`);
        }
        else if (errorResponse &&
            errorResponse?.status >= 400) {
            console.log(`${requestId} Received ${errorResponse?.status} from ${errorResponse?.config?.url}: ${message}.`);
        }
        else {
            console.error(`${requestId} failed due to unexpected error:`, error);
        }
        return Promise.reject(error);
    });
    return axiosInstance;
}
